import Card from "@mui/material/Card";

const BodyCard = ({
  children,
  paddingTop = 5,
  paddingBottom = 25,
  sx = {},
}) => (
  <Card
    sx={{
      pt: paddingTop,
      pb: paddingBottom,
      mx: "auto",
      mt: { xs: -3, sm: -5, lg: -8 },
      mb: 4,
      position: "relative",
      zIndex: 3,
      background:
        "linear-gradient(135deg, rgba(255,255,255,0.96) 0%, rgba(250,248,243,0.98) 58%, rgba(231,240,238,0.82) 100%)",
      backdropFilter: {
        xs: "none",
        sm: "none",
        md: "saturate(200%) blur(18px)",
      },
      boxShadow: "0 18px 42px rgba(32,36,42,0.10)",
      border: "1px solid #E4DED2",
      borderRadius: "10px",
      overflow: "hidden",
      maxWidth: "1500px",
      width: "90%",
      ...sx,
    }}
  >
    {children}
  </Card>
);

export default BodyCard;
